import { SetRewardsEligibilityAction } from "../actions/CacheSetRewardsEligibility/CacheSetRewardsEligibilityActionTypes";
import { CacheReducerState } from "../models/definitions";
import { initialState } from "./CacheInitialState";

export const handleSetRewardsEligibility = (
  state = initialState,
  { payload }: SetRewardsEligibilityAction
): CacheReducerState => ({
  ...state,
  rewardsEligibility: payload.rewardsEligibility
});
